var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup87(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 21,
    viewBox: "0 0 328 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.423 10.6455C280.884 10.8818 255.345 11.0354 229.807 11.2245L153.191 11.6617L114.883 11.9335C102.114 12.0162 89.385 12.028 76.6157 11.9335L57.4618 11.768C51.0772 11.6735 44.6925 11.6262 38.3079 11.5081C25.5386 11.3072 12.7693 11.0472 0 10.6336V10.35C12.7693 9.93647 25.5386 9.68831 38.3079 9.48743C44.6925 9.36927 51.0772 9.31018 57.4618 9.22747L76.6157 9.06204C89.385 8.97932 102.114 8.97932 114.883 9.06204L153.191 9.33382L229.807 9.75922C255.345 9.9601 280.884 10.1137 306.423 10.3382V10.6455Z",
    fill: "url(#paint0_linear_612_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.074 11.0442C306.153 11.2676 309.693 17.5903 309.814 17.724C309.839 17.7511 309.947 17.6886 310.069 17.5767C310.545 17.1391 311.307 16.9183 311.956 17.0297C313.177 17.2389 314.096 18.4259 313.974 19.6351L313.943 19.9342L317.602 19.9202L321.261 19.9063L321.554 19.7669C322.099 19.5074 322.2 19.3593 324.016 16.1503C324.942 14.5145 325.738 13.101 325.786 13.0093L325.874 12.8423L325.579 12.733C324.663 12.3936 324.092 11.5269 324.092 10.475C324.092 9.35239 324.642 8.58021 325.761 8.13167C325.869 8.08854 325.789 7.93711 324.094 4.94994C322.843 2.74548 322.245 1.74188 322.084 1.57236C321.957 1.43974 321.72 1.26478 321.557 1.18354L321.261 1.0359L317.601 1.02159L313.941 1.00734L313.973 1.35903C314.074 2.4603 313.36 3.53291 312.305 3.86671C311.539 4.10923 310.486 3.88227 310.018 3.3737C309.95 3.29972 309.87 3.24021 309.84 3.24145C309.782 3.24378 306.256 9.4398 306.11 9.79621C305.98 10.1126 305.962 10.7269 306.074 11.0442ZM309.446 10.0563C309.629 9.64856 312.526 4.55818 312.659 4.41204C312.733 4.33002 312.886 4.2197 312.998 4.16693C313.19 4.07667 313.399 4.07087 316.482 4.06978C319.616 4.06869 319.769 4.07304 319.953 4.16817C320.058 4.22292 320.212 4.33873 320.295 4.42552C320.378 4.5123 321.143 5.8327 321.995 7.35965C323.612 10.2588 323.644 10.3275 323.562 10.7733C323.524 10.9793 320.483 16.3061 320.276 16.5284C320.201 16.6093 320.047 16.726 319.935 16.7876C319.732 16.8989 319.715 16.8994 316.441 16.8994C313.166 16.8994 313.15 16.8989 312.947 16.7874C312.835 16.7257 312.672 16.5974 312.586 16.5022C312.499 16.4071 312.025 15.6177 311.534 14.748C311.042 13.8784 310.372 12.694 310.045 12.1159C309.717 11.5379 309.429 11.013 309.404 10.9495C309.325 10.7506 309.348 10.2774 309.446 10.0563ZM310.108 19.9216C310.583 21.2723 312.389 21.3809 313.01 20.0961C313.282 19.5321 313.173 18.778 312.753 18.3334C312.36 17.9155 311.613 17.741 311.042 17.9336C310.283 18.19 309.835 19.1441 310.108 19.9216ZM310.059 1.91721C310.176 2.37217 310.49 2.77565 310.892 2.98712C311.052 3.0712 311.228 3.10806 311.545 3.12398C311.957 3.14466 311.994 3.13735 312.308 2.97136C313.486 2.349 313.431 0.670986 312.214 0.112444C311.888 -0.0374816 311.304 -0.0374815 310.977 0.112444C310.649 0.263304 310.347 0.556675 310.195 0.872028C310.056 1.16022 309.992 1.65634 310.059 1.91721ZM311.606 13.207C312.396 14.5977 313.061 15.7164 313.084 15.6928C313.107 15.6694 313.771 14.4861 314.559 13.0634C315.935 10.579 315.989 10.4711 315.923 10.3382C315.687 9.86054 313.154 5.20915 313.129 5.20915C313.112 5.20915 312.439 6.37544 311.633 7.80082C310.664 9.51507 310.168 10.4409 310.169 10.5355C310.17 10.6262 310.695 11.6019 311.606 13.207ZM316.638 16.0959C318.186 16.0959 319.498 16.0749 319.565 16.049C319.655 16.0145 320.053 15.3642 321.082 13.5736C321.849 12.2379 322.51 11.0926 322.551 11.0284L322.625 10.9117L319.648 10.9138L316.671 10.9158L315.268 13.456C314.497 14.8531 313.858 16.0186 313.849 16.046C313.838 16.0776 314.863 16.0959 316.638 16.0959ZM315.333 7.52907L316.716 10.0823L319.641 10.0823L322.566 10.0823L322.506 9.96563C322.337 9.6384 319.829 5.16296 319.745 5.04067L319.648 4.8981L316.795 4.8981C315.226 4.8981 313.944 4.91557 313.946 4.93698C313.949 4.95839 314.573 6.12483 315.333 7.52907ZM324.926 10.8858C325.04 11.2377 325.149 11.4076 325.417 11.6519C325.719 11.9285 326.037 12.0523 326.446 12.0523C327.048 12.0523 327.6 11.7002 327.869 11.1442C328.043 10.7857 328.044 10.1652 327.871 9.82306C327.712 9.50703 327.434 9.22009 327.127 9.05466C326.909 8.93719 326.809 8.91729 326.439 8.91729C326.068 8.91729 325.967 8.9373 325.747 9.05508C325.09 9.40537 324.715 10.241 324.926 10.8858Z",
    fill: "url(#paint1_linear_612_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_612_2",
    x1: 0,
    y1: 10.5037,
    x2: 306.423,
    y2: 10.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AE7F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#894E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3912F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CDA13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFDB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FDF17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F6812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C85C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_612_2",
    x1: 317.027,
    y1: 21,
    x2: 317.027,
    y2: -4.81997e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#AE7F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#894E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3912F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CDA13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFDB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FDF17E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9F6812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C85C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup87);
export default __webpack_public_path__ + "static/media/Group 87.3f8a0745ea02510317f9e6f3133ea996.svg";
export { ForwardRef as ReactComponent };